/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CurrencyDto,
    CurrencyDtoFromJSON,
    CurrencyDtoFromJSONTyped,
    CurrencyDtoToJSON,
} from './CurrencyDto';
import {
    PersonalAssetWithValueDto,
    PersonalAssetWithValueDtoFromJSON,
    PersonalAssetWithValueDtoFromJSONTyped,
    PersonalAssetWithValueDtoToJSON,
} from './PersonalAssetWithValueDto';
import {
    PortfolioTypeEnum,
    PortfolioTypeEnumFromJSON,
    PortfolioTypeEnumFromJSONTyped,
    PortfolioTypeEnumToJSON,
} from './PortfolioTypeEnum';
import {
    ShareTypeEnum,
    ShareTypeEnumFromJSON,
    ShareTypeEnumFromJSONTyped,
    ShareTypeEnumToJSON,
} from './ShareTypeEnum';

/**
 * 
 * @export
 * @interface PortfolioDto
 */
export interface PortfolioDto {
    /**
     * 
     * @type {ShareTypeEnum}
     * @memberof PortfolioDto
     */
    shareType: ShareTypeEnum | null;
    /**
     * 
     * @type {PortfolioTypeEnum}
     * @memberof PortfolioDto
     */
    type: PortfolioTypeEnum | null;
    /**
     * 
     * @type {Array<PersonalAssetWithValueDto>}
     * @memberof PortfolioDto
     */
    personalAssets?: Array<PersonalAssetWithValueDto>;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDto
     */
    iconName: PortfolioDtoIconNameEnum;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDto
     */
    colorName: PortfolioDtoColorNameEnum;
    /**
     * 
     * @type {CurrencyDto}
     * @memberof PortfolioDto
     */
    currency: CurrencyDto;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    portfolioValue: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    realizedPortfolioValue: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    currencyImpactUnrealizedValue: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    currencyImpactRealizedValue: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    invested: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    realizedInvested: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    unrealizedProfit: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    unrealizedProfitPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    todayUnrealizedProfit: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    todayUnrealizedProfitPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    realizedProfit: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    realizedProfitPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    numberOfTrades: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    numberOfAssets: number;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioDto
     */
    isRecalculating: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioDto
     */
    processed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioDto
     */
    readOnly: boolean;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    dividends: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    dividendsNextYearPrediction: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    dividendsYield: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    dividendsYieldOnCost: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    totalValue?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    numberOfPersonalAssets: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    investownTotalValue: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    investownTotalValueSource: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    numberOfInvestownAssets: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioDto
     */
    selected: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioDto
     */
    includedInSummary: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDto
     */
    portfolioHistoryCurrencyCode: string;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioDto
     */
    lastUpdated: Date;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDto
     */
    userId: string;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioDto
     */
    recalculationEndDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDto
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDto
     */
    shareSlug: string;
}

/**
* @export
* @enum {string}
*/
export enum PortfolioDtoIconNameEnum {
    Wallet = 'Wallet',
    WalletFilled = 'WalletFilled',
    Profits = 'Profits',
    ProfitsFilled = 'ProfitsFilled',
    Trades = 'Trades',
    TradesFilled = 'TradesFilled',
    Dividends = 'Dividends',
    DividendsFilled = 'DividendsFilled',
    AccountingDocument = 'AccountingDocument',
    Bell = 'Bell',
    BellFilled = 'BellFilled',
    ChartBar = 'ChartBar',
    HeartFilled = 'HeartFilled',
    Heart = 'Heart',
    CompoundInterest = 'CompoundInterest',
    ChartBarFilled = 'ChartBarFilled'
}/**
* @export
* @enum {string}
*/
export enum PortfolioDtoColorNameEnum {
    Blue = 'blue',
    BlueLight = 'blueLight',
    BlueDark = 'blueDark',
    Purple = 'purple',
    PurpleLight = 'purpleLight',
    PurpleDark = 'purpleDark',
    Green = 'green',
    GreenLight = 'greenLight',
    GreenDark = 'greenDark',
    Primary = 'primary',
    PrimaryLight = 'primaryLight',
    PrimaryDark = 'primaryDark',
    Secondary = 'secondary',
    SecondaryLight = 'secondaryLight',
    SecondaryDark = 'secondaryDark',
    Gray = 'gray',
    GrayLight = 'grayLight',
    GrayDark = 'grayDark',
    Orange = 'orange',
    OrangeLight = 'orangeLight',
    OrangeDark = 'orangeDark',
    Red = 'red',
    RedLight = 'redLight',
    RedDark = 'redDark',
    Pink = 'pink',
    PinkLight = 'pinkLight',
    PinkDark = 'pinkDark',
    Brown = 'brown',
    BrownLight = 'brownLight',
    BrownDark = 'brownDark',
    Yellow = 'yellow',
    YellowLight = 'yellowLight',
    YellowDark = 'yellowDark'
}

export function PortfolioDtoFromJSON(json: any): PortfolioDto {
    return PortfolioDtoFromJSONTyped(json, false);
}

export function PortfolioDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shareType': ShareTypeEnumFromJSON(json['shareType']),
        'type': PortfolioTypeEnumFromJSON(json['type']),
        'personalAssets': !exists(json, 'personalAssets') ? undefined : ((json['personalAssets'] as Array<any>).map(PersonalAssetWithValueDtoFromJSON)),
        'iconName': json['iconName'],
        'colorName': json['colorName'],
        'currency': CurrencyDtoFromJSON(json['currency']),
        'portfolioValue': json['portfolioValue'],
        'realizedPortfolioValue': json['realizedPortfolioValue'],
        'currencyImpactUnrealizedValue': json['currencyImpactUnrealizedValue'],
        'currencyImpactRealizedValue': json['currencyImpactRealizedValue'],
        'invested': json['invested'],
        'realizedInvested': json['realizedInvested'],
        'unrealizedProfit': json['unrealizedProfit'],
        'unrealizedProfitPercentage': json['unrealizedProfitPercentage'],
        'todayUnrealizedProfit': json['todayUnrealizedProfit'],
        'todayUnrealizedProfitPercentage': json['todayUnrealizedProfitPercentage'],
        'realizedProfit': json['realizedProfit'],
        'realizedProfitPercentage': json['realizedProfitPercentage'],
        'numberOfTrades': json['numberOfTrades'],
        'numberOfAssets': json['numberOfAssets'],
        'isRecalculating': json['isRecalculating'],
        'processed': json['processed'],
        'readOnly': json['readOnly'],
        'dividends': json['dividends'],
        'dividendsNextYearPrediction': json['dividendsNextYearPrediction'],
        'dividendsYield': json['dividendsYield'],
        'dividendsYieldOnCost': json['dividendsYieldOnCost'],
        'totalValue': !exists(json, 'totalValue') ? undefined : json['totalValue'],
        'numberOfPersonalAssets': json['numberOfPersonalAssets'],
        'investownTotalValue': json['investownTotalValue'],
        'investownTotalValueSource': json['investownTotalValueSource'],
        'numberOfInvestownAssets': json['numberOfInvestownAssets'],
        'id': json['id'],
        'name': json['name'],
        'selected': json['selected'],
        'includedInSummary': json['includedInSummary'],
        'portfolioHistoryCurrencyCode': json['portfolioHistoryCurrencyCode'],
        'lastUpdated': (new Date(json['lastUpdated'])),
        'userId': json['userId'],
        'recalculationEndDate': (json['recalculationEndDate'] === null ? null : new Date(json['recalculationEndDate'])),
        'order': json['order'],
        'shareSlug': json['shareSlug'],
    };
}

export function PortfolioDtoToJSON(value?: PortfolioDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shareType': ShareTypeEnumToJSON(value.shareType),
        'type': PortfolioTypeEnumToJSON(value.type),
        'personalAssets': value.personalAssets === undefined ? undefined : ((value.personalAssets as Array<any>).map(PersonalAssetWithValueDtoToJSON)),
        'iconName': value.iconName,
        'colorName': value.colorName,
        'currency': CurrencyDtoToJSON(value.currency),
        'portfolioValue': value.portfolioValue,
        'realizedPortfolioValue': value.realizedPortfolioValue,
        'currencyImpactUnrealizedValue': value.currencyImpactUnrealizedValue,
        'currencyImpactRealizedValue': value.currencyImpactRealizedValue,
        'invested': value.invested,
        'realizedInvested': value.realizedInvested,
        'unrealizedProfit': value.unrealizedProfit,
        'unrealizedProfitPercentage': value.unrealizedProfitPercentage,
        'todayUnrealizedProfit': value.todayUnrealizedProfit,
        'todayUnrealizedProfitPercentage': value.todayUnrealizedProfitPercentage,
        'realizedProfit': value.realizedProfit,
        'realizedProfitPercentage': value.realizedProfitPercentage,
        'numberOfTrades': value.numberOfTrades,
        'numberOfAssets': value.numberOfAssets,
        'isRecalculating': value.isRecalculating,
        'processed': value.processed,
        'readOnly': value.readOnly,
        'dividends': value.dividends,
        'dividendsNextYearPrediction': value.dividendsNextYearPrediction,
        'dividendsYield': value.dividendsYield,
        'dividendsYieldOnCost': value.dividendsYieldOnCost,
        'totalValue': value.totalValue,
        'numberOfPersonalAssets': value.numberOfPersonalAssets,
        'investownTotalValue': value.investownTotalValue,
        'investownTotalValueSource': value.investownTotalValueSource,
        'numberOfInvestownAssets': value.numberOfInvestownAssets,
        'id': value.id,
        'name': value.name,
        'selected': value.selected,
        'includedInSummary': value.includedInSummary,
        'portfolioHistoryCurrencyCode': value.portfolioHistoryCurrencyCode,
        'lastUpdated': (value.lastUpdated.toISOString()),
        'userId': value.userId,
        'recalculationEndDate': (value.recalculationEndDate === null ? null : value.recalculationEndDate.toISOString()),
        'order': value.order,
        'shareSlug': value.shareSlug,
    };
}

